import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import Event, { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../modules/analytics/components/Event';
import CloseIcon from '../assets/CloseIcon.png';
var MessageDisplayBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(MessageDisplayBanner, _React$Component);
  var _super = _createSuper(MessageDisplayBanner);
  function MessageDisplayBanner() {
    _classCallCheck(this, MessageDisplayBanner);
    return _super.apply(this, arguments);
  }
  _createClass(MessageDisplayBanner, [{
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var containerStyle = {};
      if (backgroundColor) {
        containerStyle = _objectSpread(_objectSpread({}, containerStyle), {}, {
          backgroundColor: backgroundColor
        });
      }
      return containerStyle;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        subject = _this$props.subject,
        onClick = _this$props.onClick,
        onClose = _this$props.onClose,
        buttonText = _this$props.buttonText,
        disableButton = _this$props.disableButton;
      return /*#__PURE__*/React.createElement("div", {
        className: "fm-message-display-banner",
        style: this.getContainerStyle()
      }, /*#__PURE__*/React.createElement("div", null, subject, !disableButton && /*#__PURE__*/React.createElement(Event, {
        eventType: "click",
        event: {
          category: EVENT_CATEGORIES.ANNOUNCEMENT_EVENT_CATEGORY,
          action: EVENT_ACTIONS.ANNOUNCEMENT_SEE_MORE_ACTION
        }
      }, /*#__PURE__*/React.createElement(Button, {
        inverted: true,
        size: "tiny",
        onClick: onClick
      }, buttonText))), /*#__PURE__*/React.createElement(Button, {
        onClick: onClose,
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement(Image, {
        src: CloseIcon,
        fluid: true,
        altText: "Close Icon"
      })));
    }
  }]);
  return MessageDisplayBanner;
}(React.Component);
export { MessageDisplayBanner as default };
MessageDisplayBanner.defaultProps = {
  backgroundColor: '',
  buttonText: 'See More',
  disableButton: false
};